:host {
  display: block;
}
svg{
  stroke: var(--mainColor);
}